import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sessionId: null,
  businessId: null,
  businessName: null,
  token: null,
  tokenPreview: null,
  expiresAt: null,
  isImpersonating: false,
  loading: false,
  error: null,
};

export const impersonationSlice = createSlice({
  name: "impersonation",
  initialState,
  reducers: {
    setImpersonationSession: (state, action) => {
      const {
        sessionId,
        businessId,
        businessName,
        token,
        tokenPreview,
        expiresAt,
      } = action.payload;
      state.sessionId = sessionId;
      state.businessId = businessId;
      state.businessName = businessName;
      state.token = token;
      state.tokenPreview = tokenPreview;
      state.expiresAt = expiresAt;
      state.isImpersonating = true;
      state.error = null;
    },

    clearImpersonationSession: (state) => {
      state.sessionId = null;
      state.businessId = null;
      state.businessName = null;
      state.token = null;
      state.tokenPreview = null;
      state.expiresAt = null;
      state.isImpersonating = false;
      state.error = null;
    },

    setImpersonationLoading: (state, action) => {
      state.loading = action.payload;
    },

    setImpersonationError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setImpersonationSession,
  clearImpersonationSession,
  setImpersonationLoading,
  setImpersonationError,
} = impersonationSlice.actions;

export default impersonationSlice.reducer;
